import {z} from '@hono/zod-openapi';

const MAX_RANK = 100;
const MAX_RANK_COUNT = 10;
const MAX_PERCENT_COUNT = 101;

/**
 * `POST /pricereport/{id}/aggregations` body: the statistics_v2 filter fields (passed through
 * untouched to the shared all_cars mapping) plus what Alpha aggregates. `query_price` is my price,
 * `rank` the 1-based positions to read advertised prices at and `percent` the advertised price
 * percentiles to return. A new operation with no legacy validation order to keep, so unlike
 * the legacy write bodies it is declared in Zod.
 */
export const priceReportAggregationsRequestBodySchema = z
  .object({
    query_price: z.number().nonnegative().nullish().openapi({example: 450000}),
    rank: z
      .array(z.number().int().min(1).max(MAX_RANK))
      .max(MAX_RANK_COUNT)
      .openapi({example: [20, 40, 60]}),
    percent: z
      .array(z.number().int().min(0).max(100))
      .max(MAX_PERCENT_COUNT)
      .openapi({example: [0, 25, 50, 75, 100]}),
  })
  .passthrough()
  .openapi('PriceReportAggregationsRequestBody');

export type PriceReportAggregationsRequestBody = z.infer<
  typeof priceReportAggregationsRequestBodySchema
>;
